import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  deactivatePublicHeader,
  switchOnOffMenuBar,
} from 'actions/app.actions';

export const OVERVIEW_BACK = 'OVERVIEW_BACK';
export const STAY_STANDARD = 'STAY_STANDARD';
export const STAY_LIMITED = 'STAY_LIMITED';
export const HIDE_COMPLETELY = 'HIDE_COMPLETELY';
export const CUSTOM_URL_BACK = 'CUSTOM_URL_BACK';

export const checkHeaderEnumValue = header_style =>
  [
    OVERVIEW_BACK,
    STAY_STANDARD,
    STAY_LIMITED,
    HIDE_COMPLETELY,
    CUSTOM_URL_BACK,
  ].includes(header_style);
/**
 *
 * @param hideMenu - boolean to hide menu
 * @param pageMenuType - **REQUIRED** for smooth transition from one hidden page to another
 *
 */
export const usePublicHeaderHook = (
  hideMenu,
  pageMenuType,
  hideMenuMobile,
  opts,
) => {
  const dispatch = useDispatch();

  const { forceHideMenuBar } = useSelector(state => {
    return {
      forceHideMenuBar: state.app.forceHideMenuBar,
      menuType: state.app.menuType,
      headerMenuOpts: state.app.headerMenuOpts,
    };
  });

  useEffect(() => {
    dispatch(switchOnOffMenuBar(hideMenu, pageMenuType, hideMenuMobile, opts));
    return () => {
      if (!opts?.doNotDeactivate) {
        dispatch(deactivatePublicHeader(pageMenuType));
      }
    };
    //eslint-disable-next-line
  }, [hideMenu, hideMenuMobile, pageMenuType]);

  return {
    switchOnOffMenuBar,
    forceHideMenuBar,
  };
};
